export default __webpack_public_path__ + "static/media/client-07.082a248c.png";